/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractAgentManagedHttpService } from '@src/app/shared/abstract-agent-managed-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { Action } from '@src/app/model/action';

import { RequestService } from '@src/app/modules/crm/request.service';
import { ActivatedRoute } from '@angular/router';
import { User } from '@src/app/model/user';

@Injectable({
    providedIn: 'root'
})
export class ActionService extends AbstractAgentManagedHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);
    private activeRoute = inject(ActivatedRoute);
    private reqSvc = inject(RequestService);


    protected get baseUrl() {
        return this.getAjaxPath('crm/actions');
    }
    protected cache: Action[];
    protected typeString = 'Action';

    complete(action: Action, user: User) {
        // teamId addresses the write to the OMC that owns the action - see AbstractAgentManagedHttpService.
        const newAction = { id: action.id, revision: action.revision, teamId: action.teamId } as Action;
        newAction.completedAt = new Date().getTime() / 1000;
        newAction.completedById = user.id;
        return this.put(newAction)
    }
}
